import { Validator, NG_VALIDATORS, UntypedFormControl } from '@angular/forms';
import { Directive, Input } from '@angular/core';

@Directive({
    selector: '[appForbiddenNameValidator]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: ForbiddenNameValidatorDirective, multi: true }
    ],
    standalone: false
})
export class ForbiddenNameValidatorDirective implements Validator {

  @Input('appForbiddenNameValidator') forbidden: unknown[];

  validate(c: UntypedFormControl) {

    const value: unknown = c.value;

    const exist = this.forbidden?.some(a => a === value);
    if (exist) {
      return { forbiddenName: true };
    } else {
      return null;
    }
  }
}
